import { memo } from "react";

import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import { type RenderGroupRowCellProps } from ".";
import PersonalSettingsSpacesGroupCell from "../Cell";

const PersonalSettingsSpacesTableGroupRowCellDescription = memo(
  (props: RenderGroupRowCellProps) => {
    return (
      <PersonalSettingsSpacesGroupCell {...props}>
        <TableCellEmpty />
      </PersonalSettingsSpacesGroupCell>
    );
  }
);

PersonalSettingsSpacesTableGroupRowCellDescription.displayName =
  "PersonalSettingsSpacesTableGroupRowCellDescription";

export default PersonalSettingsSpacesTableGroupRowCellDescription;
